import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MaintenanceComponent } from './core/maintenance/maintenance.component';
import {
  companySetupComletedGuard,
  companySetupGuard,
} from './core/guards/company-setup.guard';
import { PrivacyPolicyComponent } from './core/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './core/terms-of-service/terms-of-service.component';
import { DeleteAccountInstructionsComponent } from './core/delete-account-instructions/delete-account-instructions.component';
import { LiveFeedComponent } from './core/live-feed/live-feed.component';
import { UserManualComponent } from './core/user-manual/user-manual.component';
import { SendSocialNetworkPostComponent } from './core/social-network-post/send-social-network-post.component';
import { VerifyEmailComponent } from './core/verify-email/verify-email.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/login/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
  },
  {
    path: 'live-feed/:id',
    component: LiveFeedComponent,
  },
  {
    path: 'social-network/post',
    component: SendSocialNetworkPostComponent,
  },
  {
    path: 'delete-account-instructions',
    component: DeleteAccountInstructionsComponent,
  },
  {
    path: 'coupon-validation',
    component: UserManualComponent,
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent,
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [AuthGuard, companySetupGuard],
  },
  {
    path: 'setup',
    loadChildren: () =>
      import('./modules/company-setup/company-setup.module').then(
        (m) => m.CompanySetupModule
      ),
    canActivate: [companySetupComletedGuard],
  },
  {
    path: 'join-lomy',
    loadChildren: () =>
      import('./modules/join-lomy/join-lomy.module').then(
        (m) => m.JoinLomyModule
      ),
  },
  // The wildcard route will only catch paths that are not handled by the server
  // or by specific Angular routes defined above
  { path: 'secure-admin/**', children: [] },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
